import React, { useState, useEffect, useRef } from 'react';

function useScrollVisible(threshold) {
  var ref = useRef(null);
  var [visible, setVisible] = useState(false);
  var done = useRef(false);

  useEffect(function () {
    var el = ref.current;
    if (!el) return;
    var observer = new IntersectionObserver(
      function (entries) {
        if (entries[0].isIntersecting && !done.current) {
          setVisible(true);
          done.current = true;
        }
      },
      { threshold: threshold || 0.1 }
    );
    observer.observe(el);
    return function () { observer.disconnect(); };
  }, [threshold]);

  return [ref, visible];
}

export const AnimatedSection = (props) => {
  var children = props.children;
  var className = props.className || '';
  var delay = props.delay || 0;
  var direction = props.direction || 'up';

  var result = useScrollVisible(0.1);
  var ref = result[0];
  var visible = result[1];

  var offsets = { up: 'translate-y-10', down: '-translate-y-10', left: 'translate-x-10', right: '-translate-x-10' };
  var offset = offsets[direction] || offsets.up;
  var animCls = visible ? 'opacity-100 translate-x-0 translate-y-0' : 'opacity-0 ' + offset;

  return React.createElement('div', {
    ref: ref,
    className: 'transition-all duration-700 ease-out ' + className + ' ' + animCls,
    style: { transitionDelay: delay + 'ms' }
  }, children);
};

export const StaggerChildren = (props) => {
  var children = props.children;
  var className = props.className || '';
  var staggerDelay = props.staggerDelay || 100;

  var result = useScrollVisible(0.05);
  var ref = result[0];
  var visible = result[1];

  var items = React.Children.toArray(children);

  return React.createElement('div', { ref: ref, className: className },
    items.map(function (child, index) {
      var cls = visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8';
      var dl = visible ? index * staggerDelay : 0;
      return React.createElement('div', {
        key: index,
        className: 'transition-all duration-500 ease-out ' + cls,
        style: { transitionDelay: dl + 'ms' }
      }, child);
    })
  );
};
